<ng-container *ngIf="!select">
  <div class="form-group row mb-{{ formMargin }}">
    <app-custom-form-label
      *ngIf="label?.length"
      [label]="label"
      [required]="required"
      [toolTip]="tooltipText"
      [showInfoAsTooltip]="showInfoAsTooltip"
      [link]="link"
      class="col-md-{{ labelSize }} col-xs-12 weight-600 {{
        showInfoAsTooltip ? 'mt-2' : 'mt-0'
      }} {{ +labelSize === 12 && +inputSize === 12 ? 'mb-1' : 'mb-0' }}"
    >
    </app-custom-form-label>
    <div
      class="col-md-{{ 12 - inputSize - labelSize }}"
      *ngIf="12 - inputSize - labelSize > 0 && label?.length"
    ></div>
    <div class="col-md-{{ inputSize }} col-xs-12" [nbSpinner]="loading">
      <input
        [fieldSize]="fieldSize"
        [type]="type"
        nbInput
        [fullWidth]="fullWidth"
        [name]="fieldName"
        [id]="fieldId"
        [formControl]="customFormControl"
        [class]="inputClass"
        [placeholder]="placeholder"
        [pattern]="patternMatch"
        [required]="required"
        [minlength]="minlength"
        [maxlength]="maxlength"
        [disabled]="disabled"
        [nbTooltip]="disabledMsg"
        [nbTooltipDisabled]="!disabledMsg"
        [disabled]="disabled"
        [status]="
          customFormControl?.dirty
            ? customFormControl?.invalid
              ? 'danger'
              : 'success'
            : 'basic'
        "
        [min]="min"
        [max]="max"
        [autocomplete]="autocomplete"
        (ngModelChange)="onChangeInputVal($event)"
      />
      <!-- <div class="mt-1" *ngIf="disabled && disabledMsg?.length">
        <p class="caption status-danger mb-0">
          {{ disabledMsg }}
        </p>
      </div> -->
      <div
        class="mt-1"
        *ngIf="
          customFormControl?.invalid &&
          (customFormControl?.touched || customFormControl?.dirty)
        "
      >
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.required"
        >
          {{ missingMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.notInteger"
        >
          Only integer values are allowed
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.notFloat"
        >
          Only floating point values are allowed
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.selectValueMismatch"
        >
          Select the value from available options
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.pattern"
        >
          {{ invalidPatternMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="
            customFormControl?.errors?.maxlength ||
            customFormControl?.errors?.minlength
          "
        >
          {{ invalidLengthMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="
            customFormControl?.errors?.min || customFormControl?.errors?.max
          "
        >
          {{ invalidNumberMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.[customValidationError]"
        >
          {{ customFormControl?.errors?.[customValidationError] }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.nonUnique"
        >
          {{ notUniqueMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.compareField"
        >
          {{ compareFieldErrMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.['uniquePatternProperty']"
        >
          {{
            uniquePatternPropertyMsg ||
              'This value must be unique across all entries'
          }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.email"
        >
          {{ invalidEmailMsg }}
        </p>
      </div>
      <div class="mt-2">
        <ng-content select="[fieldNote]"></ng-content>
      </div>
    </div>
  </div>
  <hr *ngIf="showFormDivider" />
</ng-container>

<ng-container *ngIf="select">
  <div class="form-group row mb-{{ formMargin }}">
    <app-custom-form-label
      *ngIf="label?.length"
      [label]="label"
      [required]="required"
      [toolTip]="tooltipText"
      [showInfoAsTooltip]="showInfoAsTooltip"
      class="col-md-{{ labelSize }} col-xs-12 weight-600 mt-0 {{
        +labelSize === 12 && +inputSize === 12 ? 'mb-1' : 'mb-0'
      }}"
    >
    </app-custom-form-label>
    <div
      class="col-md-{{ 12 - inputSize - labelSize }}"
      *ngIf="12 - inputSize - labelSize > 0"
    ></div>
    <div class="col-md-{{ inputSize }}">
      <nb-select
        [fullWidth]="fullWidth"
        [size]="fieldSize"
        [id]="fieldId"
        [formControl]="customFormControl"
        [placeholder]="placeholder"
        [pattern]="patternMatch"
        [required]="required"
        class="{{ inputClass }} bg-white rounded"
        [multiple]="multiple"
        [disabled]="disabled"
        [nbTooltip]="disabledMsg"
        [nbTooltipDisabled]="!disabledMsg"
        [status]="
          customFormControl?.dirty
            ? customFormControl?.invalid
              ? 'danger'
              : 'success'
            : 'basic'
        "
        appMinimumOptionSelectionValidation="{{ multiSelectMin }}"
        (ngModelChange)="onChangeInputVal($event)"
        [nbSpinner]="loading"
        (selectedChange)="writeValue($event)"
      >
        <nb-option [value]="null" *ngIf="showClearSelectionOption"
          >Clear Selection</nb-option
        >
        <nb-option
          *ngFor="let option of selectValues"
          [disabled]="
            option?.disabled || shouldOptionBeDisabled(option?.value, option)
          "
          value="{{ option.value }}"
          class="d-flex align-item-center"
          [ngClass]="{
            'justify-content-between': option?.tooltip || option?.icon
          }"
        >
          {{ option?.label }}
          <nb-icon
            *ngIf="option?.tooltip"
            icon="info-outline"
            [nbTooltip]="option?.tooltip"
            [nbTooltipTrigger]="'hover'"
            (click)="$event.stopPropagation()"
          ></nb-icon>
          <nb-icon
            [icon]="option?.icon"
            [nbTooltip]="option?.iconTooltip"
            [nbTooltipDisabled]="!option?.iconTooltip?.length"
            [status]="option?.iconStatus"
            pack="fci"
            *ngIf="option?.icon"
            (click)="byCustomIconClick(option, $event)"
          ></nb-icon>
        </nb-option>
      </nb-select>
      <div
        *ngIf="customFormControl?.invalid && customFormControl?.touched"
        class="mt-1"
      >
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.required"
        >
          {{ missingMsg }}
        </p>
        <p
          class="caption status-danger"
          *ngIf="
            customFormControl?.errors?.minArrayLength ||
            customFormControl?.errors?.minSelection
          "
        >
          {{ minSelectionErrorMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.selectValueMismatch"
        >
          Select the value from available options
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.compareField"
        >
          {{ compareFieldErrMsg }}
        </p>
        <p
          class="caption status-danger mb-0"
          *ngIf="customFormControl?.errors?.['uniquePatternProperty']"
        >
          {{
            uniquePatternPropertyMsg ||
              'This value must be unique across all entries'
          }}
        </p>
      </div>
      <!-- <div class="mt-1" *ngIf="disabled && disabledMsg?.length">
        <p class="caption status-danger mb-0">
          {{ disabledMsg }}
        </p>
      </div> -->
      <div class="mt-2">
        <ng-content selector="[fieldNote]"></ng-content>
      </div>
    </div>
  </div>
  <hr *ngIf="showFormDivider" />
</ng-container>
